import { Button, Dialog, Typography } from '@sravni/react-design-system';
import { useAuthLoginLink } from '@sravni/react-utils';

import styles from './auth-popup.module.scss';

interface IProps {
  showPopup: boolean;
  handleClose: () => void;
}

export const AuthPopup: React.FC<IProps> = ({ showPopup, handleClose }) => {
  const authLoginLinkProps = useAuthLoginLink();

  return (
    <Dialog visible={showPopup} onClose={handleClose} className={styles.popup}>
      <Dialog.Header title={<Typography.Heading level={4}>Авторизируйтесь на Сравни</Typography.Heading>} />
      <Dialog.Content>
        <Typography.Link {...authLoginLinkProps}>
          <Button color={'dark'} variant={'primary'} block>
            Войти
          </Button>
        </Typography.Link>
      </Dialog.Content>
    </Dialog>
  );
};
